export const CheckboxDropdownTypes = {
  SINGLE_SELECTION: 'singleSelection'
};